var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "list-card van-hairline--surround",
      on: { click: _vm.linkTo }
    },
    [
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("姓名:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(_vm._s(_vm.item.name || ""))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("性别:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(_vm._s(_vm.item.gender == "0" ? "男" : "女"))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("手机号:")]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(_vm._s(_vm.item.mobile || ""))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [
          _vm._v(
            _vm._s(
              _vm.item.birthday
                ? "生日"
                : _vm.item.weddingDate
                ? "结婚纪念日"
                : ""
            ) + ":"
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "list-content fl" }, [
          _vm._v(
            _vm._s(
              _vm.item.birthday
                ? _vm.item.birthday
                : _vm.item.weddingDate
                ? _vm.item.weddingDate
                : ""
            )
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "list-line clear" }, [
        _c("p", { staticClass: "list-title fl" }, [_vm._v("VIP等级:")]),
        _vm._v(" "),
        _vm.item.vip
          ? _c(
              "p",
              {
                staticClass: "VIP-starts fl",
                style: "width:" + _vm.item.vip * 0.4 + "rem"
              },
              _vm._l(_vm.item.vip, function(item, index) {
                return _c("img", {
                  key: index,
                  staticClass: "start",
                  attrs: {
                    src: require("@/assets/img/vipStar.png"),
                    alt: "",
                    srcset: ""
                  }
                })
              }),
              0
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b086fd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b086fd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/components/clientCareCard.vue
// module id = null
// module chunks = 